import React, { useState, useEffect, useContext, Component } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
import axiosInstance, { weburl } from "../../../axiosInstance";

import Footer from "../../components/Footer";
import Header from "../../components/Header";
import LoadingScreen from "../../components/LoadingScreen";
import getDecryptData from "../../../helper/getDecryptData";
import getCookie from "../../../helper/getCookie";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
 
// import required modules
import { Pagination, Navigation,Autoplay } from 'swiper/modules';
import CreateSlug from "../../components/extra/CreateSlug";

const VendorHome = () => {
 
   const navigate = useNavigate();
 
 
  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
    const [Data, setData] = useState([]);
    const [slug, setSlug] = useState(null);

  const { id } = useParams();

  

    const getcategoryProductUserData = async (stateSlug) => {
 
  
    
    setloading(true);

    try {

  const { data } = await axiosInstance.get(`/get-catgeory-product-vendor?userId=${id}&location=${stateSlug}`);
      setData(data.categoriesWithProducts || []);       // Delay the execution of buildScript by 1 secon
  
    } catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  };


  const getUserData = async () => {

    const decryptdatajson = await getDecryptData();
    const senderId = decryptdatajson?._id;

    setloading(true);

    try {
      const { data } = await axiosInstance.get(`/get-user-home/${id}`);
      setPage(data.Mpage);
      console.log(data);
      // Delay the execution of buildScript by 1 secon
 
    } catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  };

 

  useEffect(() => {
    getUserData();

    window.scrollTo(0, 0);

         const location = localStorage.getItem('location');
    if( location !== "[object Object]" && location){
      const stateSlug = CreateSlug(location);
     setSlug(stateSlug);
    getcategoryProductUserData(location);
    }else{
        
        toast.error('Please choose location first')
        navigate('/')
     }
  }, [id]);



  

  return (
    <>
      <Header />
<div className="container">
<div className="d-flex align-items-center gap-2 justify-content-between p-3 border-bottom">

       <h2 className="m-0 p-0">
        {Page?.profile ?  <img src={`${weburl}${Page?.profile}`} width={'50%'} />  : Page.username  }
      </h2>

    <div className="d-flex align-items-center justify-content-center" >
        <div class="dropdown">
  <button class="btn btn-primary text-white dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
   Category
  </button>
  <ul class="dropdown-menu">
             {
Data.map((category, index) => {
  return (
     <li><Link class="dropdown-item" to={`/${slug}/${category.slug}`} >  {category.title}{" "} </Link></li>
                     
  )})}

  </ul>
</div>
    </div>
</div>
</div>


     <div className="container my-2 mt-4 ">
          <div className="row">
            <div className="col-12">
              <h2> Service Category</h2>
            </div>
          </div>
          <div className="row py-2   ">

          {
Data.map((category, index) => {
  return (
    <div className="col-md-3 col-6 mb-2" key={index}>
    <div className="p-0 bg-light-blue rounded">
      <Link className="col py-2 " to={`/${slug}/${category.slug}`}>
        <img
          style={{
            width: "100%",

            objectFit: "cover",
            aspectRatio: "1/1",
          }}
          alt={category.title}
          width="100%"
          className="rounded"
          src={category.image}
        />

        <h5 className="text-center text-primary fs-lg px-2 py-2">
          {" "}
          {category.title}{" "}
        </h5>
      </Link>
    </div>
  </div>
                 
                 
  )})}


             
          </div>
        </div>


{
Data.map((category, index) => {
  return (
<>

 
     <div className="container py-4 pt-sm-5 "  key={index} >
       {/* Heading */}
       <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
         <h2 className="h3 mb-0 me-2">{category.title}</h2>
         <div className="ms-n4">
           {/* <a
             className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
             href="#"
           >
             View All
             <i className="ri-arrow-right-line ms-1" />
           </a> */}
         </div>
       </div>
       {/* Heading */}
       {/* Product Cards */}


       <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
         {/* Product Card */}
         <Swiper breakpoints={{
           300: {
             slidesPerView: 1,
             spaceBetween: 10, // Set the gap between slides for window width <= 400px
           },
           768: {
             slidesPerView: 3,
             spaceBetween: 20, // Set the gap between slides for window width <= 768px
           },
           992: {
             slidesPerView: 3,
             spaceBetween: 25, // Set the gap between slides for window width <= 992px
           },
           1200: {
             slidesPerView: 3,
             spaceBetween: 25, // Set the gap between slides for window width <= 1200px
           },
         }}
           pagination={true} navigation={true} modules={[Pagination, Navigation]} className="swiper-wrapper" >
 

         {category?.products.map((product, index) => {
                

                 return (

<SwiperSlide key={index}>

  {/* Product */}
                            <div className="w-100">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                               
                                {/* Preview Image */}
                                <div className="card-body p-2 ">
                                  {/* Product Category */}

                                  {/* <a
                                    className="product-category d-block fs-sm pb-1"
                                    href="#"
                                  >
                                    Smartphones
                                  </a> */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
<div className="col">

<h3 className="product-title  mt-2">
                                    <Link to={`/product/${product.slug}`}>
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
</div>
 <div className="col-md-4 text-end">
 <span class="badge btn text-danger bg-white btn-outline-danger">Health</span>

 
 </div>
                                 
                                  </div>

                                  <div className="row justify-content-between w-100 p-0 m-0">
                                    <div className="col">
                                    
                                  
<b className="d-block m-0 p-0">   <i class="ri-microscope-line"></i> {product.features.length} Parameters  </b> 
<div>Include</div>
                                    </div>

                                    <div className="col text-md-end fs-8">
                                    
                                  
                                    <b className="d-block m-0 p-0">   <i class="ri-calendar-todo-fill"></i>
                                     Report  </b> 
                                    <div>Same Day</div>
                                      </div>

                                  </div>


                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
                                  <div className="product-price col mt-2 ">
                                    {product.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{product.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{product.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                  <Link className="btn btn-sm btn-primary col-md-1 w-auto mt-2 " to={`/product/${product.slug}`}>
Book Now
                                  </Link>
                                  </div>
                             
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                            </div>
                            {/* Product */}

</SwiperSlide>
              

                 )
               }) }




         </Swiper >

       </div>


       {/* Product Cards */}
     </div>
   
     </>
)})
}
  
   
      <Footer />
    </>
  );
};

export default VendorHome;
